import Shippings from '../../../store/shippings';

angular
    .module('festzelt-os.shippings')
    .factory('Shippings', [
        '$injector',
        'Shipping',
        ($injector, Shipping) => new Shippings(Shipping, {
            injector: $injector
        })
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/shippings/store/shippings.js